import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'section-h',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './section-h.component.html',
  styleUrl: './section-h.component.css'
})
export class SectionHComponent implements OnInit, OnChanges {

  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection10 = new EventEmitter<any>();

  yesNo = EYesNo;
  sectionHForm: FormGroup = new FormGroup([]);

  radioQuestions = [
    {
      id: 'weapons_access',
      questionText: 'Does the student own or have access to weapons? *',
      formControlName: 'weapons_access',
      infoFormControlName: 'weapons_access_information',
      label: 'Please explain: *'
    },
    {
      id: 'weapons_practice',
      questionText: 'Has the student used or practiced with weapons? *',
      formControlName: 'weapons_practice',
      infoFormControlName: 'weapons_practice_information',
      label: 'Please explain: *'
    },
    {
      id: 'acquire_weapon',
      questionText: 'Has the student attempted to acquire a weapon? *',
      formControlName: 'acquire_weapon',
      infoFormControlName: 'acquire_weapon_information',
      label: 'Please explain: *'
    },
    {
      id: 'attack_plan',
      questionText: 'Does the student have an attack plan? *',
      formControlName: 'attack_plan',
      infoFormControlName: 'attack_plan_information',
      label: 'Please explain: *'
    },
    {
      id: 'stalking_behavior',
      questionText: 'Has the student exhibited stalking behavior? *',
      formControlName: 'stalking_behavior',
      infoFormControlName: 'stalking_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'boundary_probing',
      questionText: 'Has the student exhibited boundary probing behavior (i.e., testing limits, seeing what he/she can get away with, escalating misbehavior)? *',
      formControlName: 'boundary_probing',
      infoFormControlName: 'boundary_probing_information',
      label: 'Please explain: *'
    },
    {
      id: 'desensitizing_behavior',
      questionText: 'Has the student engaged in desensitizing behavior in the real world or in the virtual world (i.e., practicing target shooting to get used to the feel of firing weapons, playing violent video games, practicing hurting animals)? *',
      formControlName: 'desensitizing_behavior',
      infoFormControlName: 'desensitizing_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'dehumanizing_behavior',
      questionText: "Has the student engaged in dehumanizing behavior in the real world or in the virtual world (i.e., referring to peers or siblings as 'it' or using a non-human classification)?* ",
      formControlName: 'dehumanizing_behavior',
      infoFormControlName: 'dehumanizing_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'casing_behavior',
      questionText: 'Has the student exhibited casing behavior (i.e., taking photos of the school, acquiring maps or aerials)? *',
      formControlName: 'casing_behavior',
      infoFormControlName: 'casing_behavior_information',
      label: 'Please explain: *'
    },
    {
      id: 'suspicious_behavior',
      questionText: 'Has the student exhibited any other suspicious behavior? *',
      formControlName: 'suspicious_behavior',
      infoFormControlName: 'suspicious_behavior_information',
      label: 'Please explain: *'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.fullTeamAssessmentData?.[question.formControlName]) || this.yesNo.No, Validators.required);
      group[question.infoFormControlName] = new FormControl({ value: this.fullTeamAssessmentData?.[question.infoFormControlName] || '', disabled: this.fullTeamAssessmentData?.[question.infoFormControlName] ? false: true });
    });
    group['h_additional_info'] = new FormControl(String(this.fullTeamAssessmentData?.h_additional_info) || this.yesNo.No, Validators.required);    

    this.sectionHForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.sectionHForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.sectionHForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveSectionH(): void {
    if (this.sectionHForm.valid) {
      this.onSaveSection10.emit(this.sectionHForm.value);
    }
  }

}
